/**
 * @author Красильников Даниил <dkrasilnikov@gmail.com>
 * @link https://t.me/krasilneg
 */

import { createContext } from 'react';
import { Background } from './Background.class';

const BackgroundContext = createContext<Background>(new Background());

export default BackgroundContext;